var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$store.getters['Application/isLoading'])?_c('div',{staticClass:"loader"},[_c('loader',{attrs:{"size":50}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }